var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "链接名称" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "链接名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.urlName,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "urlName", $$v)
                            },
                            expression: "listPram.urlName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isMiniProgramCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "归属客户" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                filterable: "",
                                remote: "",
                                clearable: "",
                                placeholder: "请选择归属客户",
                                "remote-method": _vm.searchCustomer,
                              },
                              on: {
                                "visible-change": _vm.onCustomerVisibleChange,
                                change: _vm.handerSearch,
                              },
                              model: {
                                value: _vm.listPram.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "customerId", $$v)
                                },
                                expression: "listPram.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMiniProgramCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "权限" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.authority,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "authority", $$v)
                                },
                                expression: "listPram.authority",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "指定卡片展示", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "指定卡片不展示", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMiniProgramCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "指定卡片" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                "remote-method": _vm.remoteMethod,
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleAgreementSearch,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.fuCartIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "fuCartIds", $$v)
                                },
                                expression: "listPram.fuCartIds",
                              },
                            },
                            _vm._l(_vm.brandOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.card_name,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:company-design-auth:save"],
                      expression: "['admin:company-design-auth:save']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerOpenEdit({})
                    },
                  },
                },
                [_vm._v("添加链接")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "id", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "urlName", label: "链接名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "归属客户",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "urlType", label: "类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            \t\t\t" +
                            _vm._s(_vm.transportShowType(scope.row.urlType)) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "urlParam", label: "参数" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "productNum", label: "权限" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.showTypeMap[scope.row.authority])),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.fuCartName))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.userType == 1
                ? _c("el-table-column", {
                    attrs: { prop: "platformName", label: "创建平台" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:company-design-auth:update"],
                                expression:
                                  "['admin:company-design-auth:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:company-design-auth:delete"],
                                expression:
                                  "['admin:company-design-auth:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditJump", {
        ref: "EditJumpRef",
        attrs: { "user-type": _vm.userType },
        on: { doRefresh: _vm.handlerGetListData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }